<template>
  <hsp-layout>
    <template v-slot:sidebar>
      <side-bar
        :background-color="sidebarBackground"
        short-title="HSP"
        title="HSP">
        <template slot="links">
          <sidebar-item
            :link="{
              name: 'Users',
              icon: 'tim-icons icon-badge',
              path: { name: 'Users' }
            }">
          </sidebar-item>
          <sidebar-item
            :link="{
              name: 'Add User',
              icon: 'tim-icons icon-simple-add',
              path: { name: 'AddUser' }
            }">
          </sidebar-item>
        </template>
      </side-bar>
    </template>
  </hsp-layout>
</template>
<script>
  import HspLayout from './HspLayout';

  export default {
    data() {
      return {
        sidebarBackground: 'primary' //vue|blue|orange|green|red|primary,
      };
    },
    components: {
      HspLayout
    }
  }
</script>
